import { EduConfig } from './eduConfig';
import { EduFormField, EduQueryParameter, EduKeyValueMap } from './eduConstants';

export const resolveQueryParameterValue = (queryParamKey: string, value: string) => {
  if (!value) {
    return null;
  }

  switch(queryParamKey?.toLowerCase()) {
    case EduQueryParameter.ProductId:
        return EduConfig.products[value]?.name;
    case EduQueryParameter.ClientId:
      return EduKeyValueMap.ClientNames[value];
    case EduQueryParameter.PlatformId:
      return EduKeyValueMap.PlatformNames[value];
    case EduQueryParameter.ProductFeatureAreaId:
      return EduKeyValueMap.ProductFeatureAreaNames[value];
    case EduQueryParameter.LmsId:
      return EduKeyValueMap.LmsNames[value];
    default:
      return value;
  }
}

const reverseDictionary = (dictionary: { [key: string]: string}) => {
  return Object.keys(dictionary).reduce((reversedObject, key) => {
    reversedObject[dictionary[key]] = key;
    return reversedObject;
  }, {});
}
const lmsNamesToIds = reverseDictionary(EduKeyValueMap.LmsNames);
const productFeatureAreaNamesToIds = reverseDictionary(EduKeyValueMap.ProductFeatureAreaNames);

/**
 * Resolves the provided text to the value that should be used as the default.
 * For text inputs, the text will be used as is.
 * For dropdowns, the text will be evaluated to the key of the option to be selected.
 * @param fieldId The ID of the target field
 * @param text Text value to be evaluated
 * @returns Value to be used as default
 */
export const getDefaultFieldValueFromText = (fieldId: EduFormField, text: string) => {
  if (!text) {
    return null;
  }

  switch(fieldId) {
    case EduFormField.LMS:
      return lmsNamesToIds[text];
    case EduFormField.ProductFeatureArea:
      return productFeatureAreaNamesToIds[text];
    default:
      return text;
  }
}